// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Empreendimento } from "../interfaces/Empreendimento";
import { buscarEmpreendimentosService } from "../services/buscarEmpreendimentosService";

export const useEmpreendimentosSystem = () => {
  const { isLoading, data, error } = useFetch<Empreendimento[]>(
    true, // sempre faz fetch, não depende de nada
    buscarEmpreendimentosService,
    [] // deps vazias: não tem parâmetro que possa mudar
    // sem args: não tem o que enviar
  );

  return { isLoading, data, error };
};
